import { Injectable } from '@angular/core';
import { General_Config } from './General_Config';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor() { }

  isAdmin() {
    const role = window.localStorage.getItem(General_Config.session_key + 'role');
    return role;
  }
}
